/* global window */
export const jQuery = typeof window !== 'undefined' && window.jQuery ? window.jQuery : { fn: {} };
